import {
  ActionReducerMap,
  combineReducers,
  createReducer,
  on,
  Action,
} from '@ngrx/store';
import { SuccessStories, SuccessStoriesState } from './state';
export * from './state';
import * as Actions from './actions';
export { Actions as Actions };

export const successStoriesStateFeatureKey = 'successStory';

const initialStatisticsState: SuccessStories = <SuccessStories>{ stories: [] };

export const getSuccessStoriesReducer = createReducer(
  initialStatisticsState,
  on(Actions.getSuccessStories, currState => ({
    ...currState,
    isLoadingStories: true,
    isDeleted: false,
  })),
  on(Actions.getSuccessStoriesSuccess, (currState, payload) => {
    const { stories, pages, pageNo, pageSize, totalItems } =
      payload.data.results;

    if (currState.stories.length > 0) {
      const mergedStories = currState.stories.map(
        e => ((e = stories.find(a => a.id == e.id) || e), e)
      );
      const newStories = stories.filter(
        story => mergedStories.findIndex(s => s.id === story.id) < 0
      );

      return {
        ...currState,
        pages,
        pageNo,
        pageSize,
        totalItems,
        stories: [...mergedStories, ...newStories],
        isLoadingStories: false,
      };
    }

    return {
      ...currState,
      pages,
      pageNo,
      pageSize,
      totalItems,
      stories: currState?.stories
        ? [...currState?.stories, ...payload.data.results.stories]
        : payload.data.results.stories,
      isLoadingStories: false,
    };
  }),
  on(Actions.getSuccessStoriesFailure, currState => {
    return {
      ...currState,
      isHandlingStoryChange: true,
      isLoadingStories: false,
    };
  }),
  on(
    Actions.addSuccessStories,
    Actions.updateSuccessStories,
    Actions.getSuccessStoryById,
    currState => ({
      ...currState,
      isHandlingStoryChange: false,
      handledStorySuccessfully: false,
      isLoadingStories: false,
      isLoading: true,
      isDeleted: false,
    })
  ),
  on(Actions.addSuccessStoriesSuccess, (currState, payload) => {
    const { id, title, short_description, cover_image } = payload.successStory;

    return {
      ...currState,
      updatedId: null,
      isHandlingStoryChange: false,
      handledStorySuccessfully: true,
      stories: [
        { id, title, short_description, cover_image },
        ...currState.stories,
      ],
      isLoading: false,
    };
  }),
  on(
    Actions.addSuccessStoriesError,
    Actions.updateSuccessStoriesError,
    Actions.getSuccessStoryByIdError,
    currState => {
      return {
        ...currState,
        updatedId: null,
        isHandlingStoryChange: false,
        handledStorySuccessfully: false,
        isLoading: false,
      };
    }
  ),
  on(Actions.updateSuccessStoriesSuccess, (currState, payload) => {
    const id = payload.successStory?.id;
    return {
      ...currState,
      updatedId: id,
      isHandlingStoryChange: false,
      handledStorySuccessfully: true,
      // stories,
      isLoading: false,
    };
  }),
  on(Actions.getSuccessStoryByIdSuccess, (currState, payload) => {
    return {
      ...currState,
      story: payload.story,
      isHandlingStoryChange: false,
      handledStorySuccessfully: false,
      isLoading: false,
    };
  }),
  on(Actions.deleteSuccessStorySuccess, (currState, payload) => {
    const id = payload.story.id;

    const stories = currState.stories.filter(story => story.id === id);

    return {
      ...currState,
      updatedId: null,
      isHandlingStoryChange: false,
      handledStorySuccessfully: false,
      isDeleted: true,
      stories,
      isLoading: false,
    };
  })
);

const reducerMap: ActionReducerMap<SuccessStoriesState> = {
  successStoriesData: getSuccessStoriesReducer,
};

const successStoriesSubReducer = combineReducers(reducerMap);

export function successStoriesReducer(
  state: SuccessStoriesState,
  action: Action
) {
  return successStoriesSubReducer(state, action);
}
